import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output,
  signal
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { MappingService } from "src/app/services/mapping.service";
import { PackageTagEnum } from "src/domain/client";

import { RadioButtonComponent } from "../../inputs/radio-button/radio-button.component";
import { CheckboxComponent } from "../../inputs/checkbox/checkbox.component";
import { IconComponent } from "../icon/icon.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-checkbox-card",
  templateUrl: "./checkbox-card.component.html",
  styleUrl: "./checkbox-card.component.scss",
  imports: [
    RadioButtonComponent,
    CheckboxComponent,
    IconComponent,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxCardComponent implements OnInit {
  id = input<string | undefined>();
  title = input.required<string>();
  badges = input<string[]>([]);
  badgeLabels = input<string[] | undefined>();
  subtitle = input<string | undefined>();
  extended = input.required<boolean>();
  bodyTitle = input<string | undefined>();
  body = input<string | undefined>();
  rounded = input<boolean>(false);
  radio = input<boolean>(false);
  checked = input<boolean>(false);
  formValue = input<string | undefined>();
  parentForm = input<FormGroup<any> | undefined>();
  formControlKey = input<string | undefined>();
  icon = input<string | undefined>();

  radioClicked = output<string>();

  collapsed = signal(true);

  constructor(
    public mappingService: MappingService,
    public iconService: IconService,
    public formService: FormService
  ) {}

  ngOnInit(): void {
    this.collapsed.set(!this.extended());
  }

  onToggle(): void {
    this.collapsed.update((c) => !c);
  }

  onRadioClick(event: any): void {
    if (this.checked()) event.preventDefault();
    this.radioClicked.emit(this.formValue());
  }

  determineBadgeType(badge: PackageTagEnum | string): string {
    switch (badge) {
      case PackageTagEnum.Recommended:
        return "info";
      case PackageTagEnum.Campaign:
        return "primary";
      case "short":
        return "success";
      case "short-tyre":
        return "success";
      case "medium":
        return "warning";
      case "long":
        return "danger";
      default:
        return "";
    }
  }
}
